import React, { useEffect, useState } from 'react';
import axios from 'axios';

const JobApplicationManager = () => {
  const [jobs, setJobs] = useState([]);
  const [selectedJobId, setSelectedJobId] = useState(null);
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [resume, setResume] = useState(null);
  const [coverLetter, setCoverLetter] = useState(null);
  const [successMessage, setSuccessMessage] = useState('');
  const [subscriberId, setSubscriberId] = useState('');

  useEffect(() => {
    fetchJobs();
    fetchUser();
  }, []);

  const fetchJobs = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API}/public/job-postings`, {
        withCredentials: true
      });
      setJobs(res.data.jobs || []);
    } catch (error) {
      console.error('Error fetching job listings', error);
    }
  };

  const fetchUser = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API}/check/session`, {
        withCredentials: true
      });
      if (res.data?.user?.id) {
        setSubscriberId(res.data.user.id);
      }
    } catch (error) {
      console.error('Error fetching subscriberId', error);
    }
  };

  const handleApplicationSubmit = async (e) => {
    e.preventDefault();

    if (!selectedJobId || !subscriberId || !name || !email || !phone || !resume || !coverLetter) {
      alert("Please complete all fields.");
      return;
    }

    const formData = new FormData();
    formData.append("jobId", selectedJobId);
    formData.append("subscriberId", subscriberId);
    formData.append("name", name);
    formData.append("email", email);
    formData.append("phone", phone);
    formData.append("resume", resume);
    formData.append("coverLetter", coverLetter);

    try {
      await axios.post(`${process.env.REACT_APP_API}/apply/job`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
        withCredentials: true
      });
      setSuccessMessage("Application submitted successfully!");
    } catch (error) {
      console.error("Application error:", error);
      alert("Failed to submit application.");
    }
  };

  return (
    <div className="job-applications" style={{ marginTop: '2rem' }}>
      <h3>Open Job Postings</h3>
      <ul>
        {jobs.map((job) => (
          <li key={job._id}>
            <strong>{job.title}</strong> - {job.location}
            <button onClick={() => setSelectedJobId(job._id)}>Apply</button>
          </li>
        ))}
      </ul>

      {selectedJobId && (
        <form onSubmit={handleApplicationSubmit} style={{ marginTop: '1rem' }}>
          <h4>Submit Your Application</h4>
          <input type="text" placeholder="Full Name" value={name} onChange={e => setName(e.target.value)} required />
          <input type="email" placeholder="Email" value={email} onChange={e => setEmail(e.target.value)} required />
          <input type="tel" placeholder="Phone" value={phone} onChange={e => setPhone(e.target.value)} required />
          <label>Resume (PDF or DOC):</label>
          <input type="file" accept=".pdf,.doc,.docx" onChange={e => setResume(e.target.files[0])} required />
          <label>Cover Letter (PDF or DOC):</label>
          <input type="file" accept=".pdf,.doc,.docx" onChange={e => setCoverLetter(e.target.files[0])} required />
          <button type="submit">Submit Application</button>
        </form>
      )}

      {successMessage && <p style={{ color: 'green' }}>{successMessage}</p>}
    </div>
  );
};

export default JobApplicationManager;
